<template>
  <CustomModal v-model:visible="isVisible" :title="title" :width="width">
    <div class="text-sm text_color break-words overflow-wrap-anywhere whitespace-normal">
      {{ message }}
    </div>

    <template #footer>
      <div class="flex gap-2">
        <a-button class="secondary_medium" @click="handleCancel">
          {{ cancelText }}
        </a-button>
        <a-button :class="confirmButtonClass" @click="handleConfirm" :loading="loading">
          {{ loading ? loadingText : confirmText }}
        </a-button>
      </div>
    </template>
  </CustomModal>
</template>

<script setup>
import { computed } from 'vue';
import CustomModal from '@/components/custom/CustomModal.vue';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: 'Delete Item',
  },
  message: {
    type: String,
    default: 'Are you sure you want to delete this item?',
  },
  loading: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: 'default',
    validator: (value) => ['default', 'delete', 'danger'].includes(value),
  },
  confirmText: {
    type: String,
    default: 'Confirm',
  },
  cancelText: {
    type: String,
    default: 'Cancel',
  },
  loadingText: {
    type: String,
    default: 'Processing...',
  },
  width: {
    type: String,
    default: '450px',
  },
});

const emit = defineEmits(['update:visible', 'confirm', 'cancel']);

const isVisible = computed({
  get: () => props.visible,
  set: (value) => emit('update:visible', value),
});

const confirmButtonClass = computed(() => {
  if (props.type === 'delete' || props.type === 'danger') {
    return 'danger_medium';
  }
  return 'primary_medium';
});

const handleConfirm = () => {
  emit('confirm');
};

const handleCancel = () => {
  emit('cancel');
  isVisible.value = false;
};
</script>

<style scoped>
.danger_medium {
  display: flex;
  flex-direction: row;
  gap: 4px;
  border-radius: 8px;
  border: none !important;
  background: rgba(250, 53, 35, 0.08);
  color: #fa3523 !important;
  padding: 0 12px;
  cursor: pointer;
  font-family: 'Proxima Nova', sans-serif;
  font-weight: 600;
  align-items: center;
  box-shadow: none;
  height: 34px;
  font-size: 14px;
}

.danger_medium:hover {
  background: rgba(250, 53, 35, 0.12);
}

.danger_medium:active {
  background: rgba(250, 53, 35, 0.16);
}

.danger_medium:disabled {
  cursor: not-allowed;
  opacity: 0.2;
}
</style>
